import { render, staticRenderFns } from "./ListContacts.vue?vue&type=template&id=60fee276&"
import script from "./ListContacts.vue?vue&type=script&lang=js&"
export * from "./ListContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports